import { Button } from "@newsela/angelou";
import {
  ActionNameValue,
  ObjectTypeValue,
  withTrackEvent,
} from "@newsela/snitch";

import ActivityChoiceIndicator from "@/components/ActivityChoiceIndicator";
import ChevronRightIcon from "@/icons/ChevronRightIcon";
import {
  containerCss,
  headingCss,
  headingTextCss,
  iconCss,
  responseTextCss,
  rootCss,
} from "./QuizResponseItem.style";

interface QuizResponseItemProps {
  buttonEventProperties: {
    objectType: ObjectTypeValue;
    actionName: ActionNameValue;
    streamProperties: Record<string, unknown>;
  };
  correctAnswer: string;
  handleClick: () => void;
  selectedAnswer: string;
  shouldHideQuizAnswers: boolean;
  position: number;
}

const ButtonWithTrackEvent = withTrackEvent(Button);

const QuizResponseItem = ({
  buttonEventProperties,
  correctAnswer,
  handleClick,
  position,
  selectedAnswer,
  shouldHideQuizAnswers,
}: QuizResponseItemProps) => {
  const isCorrect = correctAnswer === selectedAnswer;

  const renderCopy = () => {
    if (isCorrect) {
      return `You chose ${selectedAnswer}, the correct answer.`;
    } else {
      return `The correct answer is ${correctAnswer}. You chose ${selectedAnswer}.`;
    }
  };

  return (
    <ButtonWithTrackEvent
      {...buttonEventProperties}
      flavor={Button.flavors.incognito}
      __cssFor={{ root: rootCss }}
      onClick={() => handleClick()}
    >
      <div css={containerCss}>
        <div>
          <div css={headingCss}>
            <span css={headingTextCss}>Question {position}</span>
            <ActivityChoiceIndicator
              labelColor={isCorrect ? "success" : "danger"}
              status={isCorrect ? "correct" : "incorrect"}
              text={isCorrect ? "correct" : "incorrect"}
            />
          </div>
          {!shouldHideQuizAnswers && (
            <p css={responseTextCss}>{renderCopy()}</p>
          )}
        </div>
        <ChevronRightIcon css={iconCss} />
      </div>
    </ButtonWithTrackEvent>
  );
};

export default QuizResponseItem;
